import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getProjects({ commit }, params = {}) {
    return axios.get('/projects/search', { params })
  },
  getProject({ commit }, id) {
    return axios.get(`/projects/${id}`)
  },
  createProject({ commit }, data) {
    return axios.post('/projects', data)
  },
  updateProject({ commit }, data) {
    return axios.put(`/projects/${data.id}`, data)
  },
}
